// DATI DEL SITO RED STONE - modifica qui i contenuti, poi esegui: yarn build
// category ammesse: pizza, food, drink, locale, serate
export const galleryImages = [
  {
    "id": "g01",
    "url": "/assets/galleria-01.jpg",
    "category": "pizza",
    "caption": "Pizza con salame piccante e olive nere",
    "placeholder": false
  },
  {
    "id": "g02",
    "url": "/assets/galleria-02.jpg",
    "category": "locale",
    "caption": "L'ingresso del Red Stone",
    "placeholder": false
  },
  {
    "id": "g03",
    "url": "/assets/galleria-03.jpg",
    "category": "locale",
    "caption": "Il bancone del bar",
    "placeholder": false
  },
  {
    "id": "g04",
    "url": "/assets/galleria-04.jpg",
    "category": "food",
    "caption": "Burger, fritti e birra alla spina",
    "placeholder": false
  },
  {
    "id": "g05",
    "url": "/assets/galleria-05.jpg",
    "category": "food",
    "caption": "Panino, frittelle e birra",
    "placeholder": false
  },
  {
    "id": "g06",
    "url": "/assets/galleria-06.jpg",
    "category": "locale",
    "caption": "Benvenuti al Red Stone",
    "placeholder": false
  },
  {
    "id": "g07",
    "url": "/assets/galleria-07.jpg",
    "category": "locale",
    "caption": "Ampio spazio fuori",
    "placeholder": false
  },
  {
    "id": "g08",
    "url": "/assets/galleria-08.jpg",
    "category": "locale",
    "caption": "",
    "placeholder": false
  },
  {
    "id": "g09",
    "url": "/assets/galleria-09.jpg",
    "category": "locale",
    "caption": "",
    "placeholder": false
  },
  {
    "id": "g10",
    "url": "/assets/galleria-10.jpg",
    "category": "locale",
    "caption": "",
    "placeholder": false
  },
  {
    "id": "g11",
    "url": "/assets/galleria-11.jpg",
    "category": "locale",
    "caption": "",
    "placeholder": false
  },
  {
    "id": "g12",
    "url": "/assets/galleria-12.jpg",
    "category": "locale",
    "caption": "",
    "placeholder": false
  },
  {
    "id": "g13",
    "url": "/assets/galleria-13.jpg",
    "category": "locale",
    "caption": "",
    "placeholder": false
  },
  {
    "id": "g14",
    "url": "/assets/galleria-14.jpg",
    "category": "locale",
    "caption": "",
    "placeholder": false
  },
  {
    "id": "g15",
    "url": "/assets/galleria-15.jpg",
    "category": "locale",
    "caption": "",
    "placeholder": false
  }
];
